import { createContext, useContext, useState, useCallback } from 'react'

export interface MediaPreviewData {
  mediaUrl: string
  mediaType: 'image' | 'video'
  fromGallery?: boolean
  post?: {
    id?: string
    authorId?: string
    author: {
      name: string
      username: string
      avatar?: string
      verified?: boolean
    }
    content?: string
    stats?: {
      likes: number
      comments: number
      shares: number
      views: number
      reposts: number
    }
    onRecordCode?: string
    createdAt?: string
    capturedAt?: string
    location?: {
      address?: string
    }
  }
  currentUserId?: string
}

interface MediaPreviewContextType {
  previewData: MediaPreviewData | null
  openPreview: (data: MediaPreviewData) => void
  closePreview: () => void
}

const MediaPreviewContext = createContext<MediaPreviewContextType>({
  previewData: null,
  openPreview: () => {},
  closePreview: () => {},
})

export function MediaPreviewProvider({ children }: { children: React.ReactNode }) {
  const [previewData, setPreviewData] = useState<MediaPreviewData | null>(null)

  const openPreview = useCallback((data: MediaPreviewData) => {
    setPreviewData(data)
    document.body.style.overflow = 'hidden'
  }, [])

  const closePreview = useCallback(() => {
    setPreviewData(null)
    document.body.style.overflow = ''
  }, [])

  return (
    <MediaPreviewContext.Provider value={{ previewData, openPreview, closePreview }}>
      {children}
    </MediaPreviewContext.Provider>
  )
}

export const useMediaPreview = () => useContext(MediaPreviewContext)
